import React from "react";
import { data } from "../data/data.js";

const Download = () => {
  // projects file
  const project = data;
  //setProject(data);

  return (
    <div name="download" className="w-full md:h-screen text-gray-800">
      <div className="max-w-[1200px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8 text-center">
          <p className="text-4xl font-bold inline border-b-4 text-gray-800 border-pink-600">Download</p>
          {/* <p className='py-6'>// Check out some of my recent work</p> */}
        </div>

        {/* container for projects */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {/* Gird Item */}
          {project.map((item, index) => (
            <div
              key={index}
              // style={{ backgroundImage: `url(${item.image})`,   }}
              // className="bg-gradient-to-r from-purple-500 to-pink-500"
              className="bg-gradient-to-r from-purple-500 to-pink-500 shadow-lg shadow-[#040c16] group container rounded-md 
               justify-center text-center items-center mx-auto content-div "
            > 
            <div className="p-8 text-center justify-center w-full mt-8">
            <span className="text-2xl font bold text-white tracking-wider text-center justify-center">{item.name}</span>
            </div>
              {/* Hover effect for images */}
              <div className="opacity-0 group-hover:opacity-100 ">
                {/* <span className="text-2xl font bold text-white tracking-wider ">{item.name}</span> */}
                <div className="pt-8 text-center ">
                  {/* eslint-disable-next-line */}
                  {/* <a href={item.github} target="_blank">
                    <button
                      className="text-center rounded-lg px-4 py-3 m-2
                       bg-white text-gray-700 font-bold text-lg"
                    >
                      Code
                    </button>
                  </a> */}
                  {/* eslint-disable-next-line */}
                  <a href={item.fileName} target="_blank">
                    <button
                      className="text-center rounded-lg px-4 py-3 m-2
                       bg-white text-gray-700 font-bold text-lg"
                    >
                      Download
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Download;
